import React, { ReactElement } from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';
import { DATE_FORMAT } from '../../constants/commonConstants';

const RangeDatePicker = (props: any): ReactElement => {

  const { RangePicker } = DatePicker;

  const disabledDate = (current: moment.Moment): boolean => {
    return current && current < moment();
  };
  return (
    <RangePicker style={{ width: '100%' }} {...props}
      disabledDate={disabledDate}
      showTime={true}
      format={DATE_FORMAT}
      ref={props?.ref}
    />
  );
};

export default RangeDatePicker;
